import { render, staticRenderFns } from "./index.vue?vue&type=template&id=21b87e64&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=21b87e64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b87e64",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/tariff/bd-cell/index.vue
// module id = null
// module chunks = 